import { WebComponent } from '@cian/mf-registry/browser';
import { createRoot, hydrateRoot } from 'react-dom/client';

import { Application } from 'shared/containers/App';
import { IApplicationContext } from '../../shared/types/applicationContext';
import { TReduxStore } from '../../shared/types/redux';
import { setWidgetOpen } from '../../shared/slices';

export type TLoginWidgetB2CMicrofrontendProps = {
  isWidgetOpen?: boolean;
};

export function createCustomElementConstructor(
  context: IApplicationContext,
  store: TReduxStore,
): CustomElementConstructor {
  class LoginWidgetB2C extends WebComponent<TLoginWidgetB2CMicrofrontendProps> {
    protected microfrontendName = context.config.getStrict<string>('projectName');
    protected imageVersion = context.config.getStrict<string>('version.commit');
    protected runtimeName = '/v1/get-b2c-login-widget';

    private applicationContext: IApplicationContext;

    public async connectedCallback(): Promise<void> {
      const s = super.connectedCallback();
      this.applicationContext = {
        ...context,
        config: context.config.attach({ instanceId: this.instance.id }),
        custom: {
          ...context.custom,
          isB2CWidget: true,
        },
      };

      return s;
    }

    protected componentDidUpdate() {
      if (this.props.isWidgetOpen !== undefined) {
        store.dispatch(setWidgetOpen(this.props.isWidgetOpen));
      } else {
        store.dispatch(setWidgetOpen(false));
      }
    }

    public async render() {
      const reactElement = <Application context={this.applicationContext} reduxStore={store} />;

      if (this.shouldHydrate) {
        hydrateRoot(this, reactElement);
      } else {
        createRoot(this).render(reactElement);
      }
    }
  }

  return LoginWidgetB2C;
}
